var path = 'public/app/plugins/panel/graph/tab_drilldown_links.html';
var html = "<drilldown-links-editor value=ctrl.panel.options.dataLinks suggestions=ctrl.linkVariableSuggestions on-change=ctrl.onDataLinksChange></drilldown-links-editor>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;